<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Logo',
})
</script>
<template>
  <div class="logo">
    <router-link :to="{ name: 'firstPage' }">
      <!-- 仅图标区域触发悬浮切换 -->
      <span 
        @mouseenter="handleMouseEnter" 
        @mouseleave="handleMouseLeave"
        style="display: inline-block; cursor: pointer;"
      >
        <SvgIcon 
          :name="isHover ? 'home' : 'logo'"  
          width="32px" 
          height="32px" 
          title="返回选择功能页" 
        />
      </span>
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script lang="ts" setup name="Logo">
import { ref } from 'vue'
import SvgIcon from '@/components/SvgIcon/index.vue'

const props = defineProps({
  title: {
    type: String,
    default: '指标管理',
    required: false,
  },
  showTitle: {
    type: Boolean,
    default: true,
    required: false,
  },
})

// 悬浮状态（默认false：显示logo）
const isHover = ref(false)

// 鼠标移入图标：切换为a图标
const handleMouseEnter = () => {
  isHover.value = true
}

// 鼠标移出图标：恢复为logo图标
const handleMouseLeave = () => {
  isHover.value = false
}
</script>

